export const generalConstants = {
  LIST_PAGES_REQUEST: 'LIST_PAGES_REQUEST',
  LIST_PAGES_SUCCESS: 'LIST_PAGES_SUCCESS',
  LIST_PAGES_FAILURE: 'LIST_PAGES_FAILURE'
};
